import { createFileRoute } from '@tanstack/react-router';

import { ChangeLog, ChangeLogsParamsSchema } from '@/features/changeLog';

export const Route = createFileRoute('/_app/changelog')({
  validateSearch: ChangeLogsParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <ChangeLog />;
}
